import React, { forwardRef, ReactNode } from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import { makeStyles } from "@material-ui/styles";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { amber, green } from "@material-ui/core/colors";
import WarningIcon from "@material-ui/icons/Warning";
import { useSnackbar } from "notistack";
import cx from "classnames";
import { Theme } from "@material-ui/core";

const variantIcon = {
	success: CheckCircleIcon,
	warning: WarningIcon,
	error: ErrorIcon,
	info: InfoIcon,
};

const useStyles1 = makeStyles((theme: Theme) => ({
	success: {
		backgroundColor: green[600],
	},
	error: {
		backgroundColor: theme.palette.error.dark,
	},
	info: {
		backgroundColor: theme.palette.primary.main,
	},
	warning: {
		backgroundColor: amber[700],
	},
	icon: {
		fontSize: 20,
	},
	iconVariant: {
		opacity: 0.9,
		marginRight: theme.spacing(1),
	},
	message: {
		display: "flex",
		alignItems: "center",
	},
}));
const getIconFromVariant = (variant: string) => {
	switch (variant) {
		case "success":
			return variantIcon.success;
		case "error":
			return variantIcon.error;
		case "info":
			return variantIcon.info;
		default:
			return variantIcon.warning;
	}
};
const getClassFromVariant = (classes: any, variant: string) => {
	switch (variant) {
		case "success":
			return classes.success;
		case "error":
			return classes.error;
		case "info":
			return classes.info;
		default:
			return classes.warning;
	}
};

interface SnackbarContentWrapperProps {
	className?: string | undefined;
	message: string | ReactNode | undefined;
	variant: "success" | "error" | "info" | "warning";
	id: string | number | undefined;
}
const SnackbarContentWrapper = forwardRef(
	(props: SnackbarContentWrapperProps, ref) => {
		const classes = useStyles1();
		const { className, message, variant, id } = props;
		const { closeSnackbar } = useSnackbar();
		const Icon = getIconFromVariant(variant);

		return (
			<SnackbarContent
				ref={ref}
				className={cx(getClassFromVariant(classes, variant), className)}
				aria-describedby="client-snackbar"
				message={
					<span id="client-snackbar" className={classes.message}>
						<Icon className={cx(classes.icon, classes.iconVariant)} />
						{message}
					</span>
				}
				action={[
					<IconButton
						key="close"
						aria-label="close"
						color="inherit"
						onClick={() => closeSnackbar(id)}
					>
						<CloseIcon className={classes.icon} />
					</IconButton>,
				]}
			/>
		);
	}
);

export { SnackbarContentWrapper };
